var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"elevation":"0","min-height":"500"}},[_c('tag-manager')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }